import { gql } from "@apollo/client";

export const UPDATE_EXPIRY_DATE_MUTATION = gql`
  mutation UpdateClientExpiryDate($id: Int!, $expiryDate: String!) {
    updateClientExpiryDate(id: $id, expiryDate: $expiryDate) {
      client {
        id
        clientId
        expiryDate
      }
    }
  }
`;
